var _rect, _path, _path2, _path3, _path4, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#EFF4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6152 17.375H13.8984",
    stroke: "#0A5F59",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7568 19.2344V15.5176",
    stroke: "#0A5F59",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0935 12.3402C13.0352 12.3343 12.9652 12.3343 12.901 12.3402C11.5127 12.2935 10.4102 11.156 10.4102 9.75602C10.4043 8.32685 11.5652 7.16602 12.9943 7.16602C14.4235 7.16602 15.5843 8.32685 15.5843 9.75602C15.5843 11.156 14.476 12.2935 13.0935 12.3402Z",
    stroke: "#0A5F59",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1248 18.5421C11.5414 18.5421 10.8764 18.4546 10.0714 17.9179C8.65978 16.9729 8.65978 15.4329 10.0714 14.4938C11.6756 13.4204 13.8748 13.2921 15.3331 14.1671",
    stroke: "#0A5F59",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#1D894E",
    strokeLinecap: "round",
    strokeDasharray: "6 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/assign.de5864eb0391976a9605523ad83c53a8.svg";
export { ForwardRef as ReactComponent };